"use client";

import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

export function AnimatedHeadline({
  lines,
  className,
  as: Tag = "h1",
}: {
  lines: string[];
  className?: string;
  as?: "h1" | "h2" | "h3";
}) {
  const reduced = useReducedMotion();

  return (
    <Tag className={cn("display-title", className)}>
      {lines.map((line, lineIndex) => {
        const words = line.split(" ");
        return (
          <span key={lineIndex} className="block">
            {words.map((word, wordIndex) => {
              const isLast =
                lineIndex === lines.length - 1 && wordIndex === words.length - 1;
              const content = isLast ? (
                <span className="gradient-text">{word}</span>
              ) : (
                word
              );

              if (reduced) {
                return (
                  <span key={`${word}-${wordIndex}`} className="inline-block whitespace-pre">
                    {content}
                    {wordIndex < words.length - 1 ? "\u00A0" : ""}
                  </span>
                );
              }

              return (
                <motion.span
                  key={`${word}-${wordIndex}`}
                  className="inline-block whitespace-pre"
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.55,
                    delay: 0.08 + lineIndex * 0.12 + wordIndex * 0.05,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                >
                  {content}
                  {wordIndex < words.length - 1 ? "\u00A0" : ""}
                </motion.span>
              );
            })}
          </span>
        );
      })}
    </Tag>
  );
}